/**
 * MagSafe cart-drawer upsells — dismiss + wallet colour ATC.
 * Always loaded from cart-drawer so Hide still works after Section Rendering
 * morphs (inline scripts in replaced HTML often never re-run).
 */
(function () {
  var CASE_KEY = 'magsafe-case-upsell-dismissed';
  var WALLET_KEY = 'magsafe-wallet-upsell-dismissed';
  var GAN_KEY = 'gan-pack-upsell-dismissed';
  var ALL_KEY = 'magsafe-cart-upsells-dismissed';

  function storageGet(key) {
    try {
      return sessionStorage.getItem(key) === '1';
    } catch (e) {
      return false;
    }
  }

  function storageSet(key) {
    try {
      sessionStorage.setItem(key, '1');
    } catch (e) {}
  }

  function caseDismissed() {
    return storageGet(CASE_KEY) || storageGet(ALL_KEY);
  }

  function walletDismissed() {
    return storageGet(WALLET_KEY) || storageGet(ALL_KEY);
  }

  function hideRoot(root, key) {
    if (!root) return;
    if (key) storageSet(key);
    root.hidden = true;
    root.classList.add('is-dismissed');
    root.setAttribute('aria-hidden', 'true');
  }

  function applyDismissedState(root) {
    if (!root) return;
    // Only cart/drawer dismissible shells — never CASE15 / cases landing (.mcu--landing).
    if (!root.matches('[data-mcu-dismissible], [data-mwu-dismissible], [data-gpu-dismissible]')) return;
    if (root.matches('[data-magsafe-case-upsell]') && caseDismissed()) {
      hideRoot(root, null);
    }
    if (root.matches('[data-magsafe-wallet-upsell]') && walletDismissed()) {
      hideRoot(root, null);
    }
    if (root.matches('[data-gan-pack-upsell]') && storageGet(GAN_KEY)) {
      hideRoot(root, null);
    }
  }

  function bindWalletInteractions(root) {
    if (!root || root.dataset.mwuBound === '1') return;
    root.dataset.mwuBound = '1';

    var addBtn = root.querySelector('[data-mwu-add]');
    var img = root.querySelector('[data-mwu-image]');
    var swatches = root.querySelectorAll('[data-mwu-swatch]');

    function selectSwatch(btn) {
      swatches.forEach(function (el) {
        el.classList.toggle('is-selected', el === btn);
        el.setAttribute('aria-pressed', el === btn ? 'true' : 'false');
      });
      if (addBtn) addBtn.setAttribute('data-variant-id', btn.getAttribute('data-variant-id') || '');
      var src = btn.getAttribute('data-image') || '';
      if (img && src) {
        img.src = src;
        var colour = btn.getAttribute('data-colour') || '';
        img.alt = colour ? 'MagSafe wallet · ' + colour : 'MagSafe wallet';
      }
    }

    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectSwatch(btn);
      });
    });
    var selected = root.querySelector('[data-mwu-swatch].is-selected') || swatches[0];
    if (selected) selectSwatch(selected);

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var id = Number(addBtn.getAttribute('data-variant-id') || 0);
        if (!id) return;
        var pmc = window.PhoneMagneticCompat;
        if (pmc && typeof pmc.addToCartVariant === 'function') {
          pmc.addToCartVariant(id, addBtn);
          return;
        }
        addBtn.disabled = true;
        var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }),
        })
          .then(function (r) {
            if (!r.ok) throw new Error('Could not add wallet');
            return r.json();
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:update'));
            if (window.theme && theme.cartDrawer && typeof theme.cartDrawer.open === 'function') {
              return;
            }
            window.location.href = rootPath + 'cart';
          })
          .catch(function (err) {
            addBtn.disabled = false;
            alert((err && err.message) || 'Could not add wallet');
          });
      });
    }
  }

  function bindGanInteractions(root) {
    if (!root || root.dataset.gpuBound === '1') return;
    root.dataset.gpuBound = '1';

    var addBtn = root.querySelector('[data-gpu-add]');
    var img = root.querySelector('[data-gpu-image]');
    var swatches = root.querySelectorAll('[data-gpu-swatch]');

    function selectSwatch(btn) {
      swatches.forEach(function (el) {
        el.classList.toggle('is-selected', el === btn);
        el.setAttribute('aria-pressed', el === btn ? 'true' : 'false');
      });
      if (addBtn) addBtn.setAttribute('data-variant-id', btn.getAttribute('data-variant-id') || '');
      var src = btn.getAttribute('data-image') || '';
      if (img && src) {
        img.src = src;
        var colour = btn.getAttribute('data-colour') || '';
        img.alt = colour ? '80W GaN · ' + colour : '80W GaN charger';
      }
    }

    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectSwatch(btn);
      });
    });
    var selected = root.querySelector('[data-gpu-swatch].is-selected') || swatches[0];
    if (selected) selectSwatch(selected);

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var id = Number(addBtn.getAttribute('data-variant-id') || 0);
        if (!id) return;
        addBtn.disabled = true;
        var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }),
        })
          .then(function (r) {
            if (!r.ok) throw new Error('Could not add charger');
            return r.json();
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:update'));
          })
          .catch(function (err) {
            addBtn.disabled = false;
            alert((err && err.message) || 'Could not add charger');
          });
      });
    }
  }

  function scan() {
    document
      .querySelectorAll('[data-magsafe-case-upsell][data-mcu-dismissible]')
      .forEach(applyDismissedState);
    document
      .querySelectorAll('[data-magsafe-wallet-upsell][data-mwu-dismissible]')
      .forEach(function (root) {
        applyDismissedState(root);
        if (!root.hidden && !root.classList.contains('is-dismissed')) {
          bindWalletInteractions(root);
        }
      });
    document.querySelectorAll('[data-gan-pack-upsell][data-gpu-dismissible]').forEach(function (root) {
      applyDismissedState(root);
      if (!root.hidden && !root.classList.contains('is-dismissed')) {
        bindGanInteractions(root);
      }
      var wrap = root.closest('[data-gpu-offers]');
      if (wrap) {
        var vis = visibleOffer(root);
        wrap.hidden = !vis;
        wrap.classList.toggle('is-dismissed', !vis);
      }
    });
    syncHideAllChips();
  }

  function visibleOffer(root) {
    return root && !root.hidden && !root.classList.contains('is-dismissed');
  }

  function syncHideAllChips() {
    document.querySelectorAll('[data-mcu-offers]').forEach(function (wrap) {
      var caseEl = wrap.querySelector('[data-magsafe-case-upsell]');
      var walletEl = wrap.querySelector('[data-magsafe-wallet-upsell]');
      var any = visibleOffer(caseEl) || visibleOffer(walletEl);
      wrap.hidden = !any;
      wrap.classList.toggle('is-dismissed', !any);
      var btn = wrap.querySelector('[data-mcu-hide-all]');
      if (btn) btn.hidden = !any;
    });
  }

  function hideAllOffers() {
    storageSet(ALL_KEY);
    storageSet(CASE_KEY);
    storageSet(WALLET_KEY);
    storageSet(GAN_KEY);
    document
      .querySelectorAll(
        '[data-magsafe-case-upsell][data-mcu-dismissible], [data-magsafe-wallet-upsell][data-mwu-dismissible], [data-gan-pack-upsell][data-gpu-dismissible]'
      )
      .forEach(function (root) {
        hideRoot(root, null);
      });
    syncHideAllChips();
  }

  // Event delegation — survives cart drawer section morphs
  document.addEventListener(
    'click',
    function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;

      var hideAll = t.closest('[data-mcu-hide-all]');
      if (hideAll) {
        ev.preventDefault();
        hideAllOffers();
        return;
      }

      var caseDismiss = t.closest('[data-mcu-dismiss]');
      if (caseDismiss) {
        var caseRoot = caseDismiss.closest('[data-magsafe-case-upsell][data-mcu-dismissible]');
        if (!caseRoot) return;
        ev.preventDefault();
        hideRoot(caseRoot, CASE_KEY);
        syncHideAllChips();
        return;
      }

      var walletDismiss = t.closest('[data-mwu-dismiss]');
      if (walletDismiss) {
        var walletRoot = walletDismiss.closest(
          '[data-magsafe-wallet-upsell][data-mwu-dismissible]'
        );
        if (!walletRoot) return;
        ev.preventDefault();
        hideRoot(walletRoot, WALLET_KEY);
        syncHideAllChips();
        return;
      }

      var ganDismiss = t.closest('[data-gpu-dismiss]');
      if (ganDismiss) {
        var ganRoot = ganDismiss.closest('[data-gan-pack-upsell][data-gpu-dismissible]');
        if (!ganRoot) return;
        ev.preventDefault();
        hideRoot(ganRoot, GAN_KEY);
        var ganWrap = ganRoot.closest('[data-gpu-offers]');
        if (ganWrap) {
          ganWrap.hidden = true;
          ganWrap.classList.add('is-dismissed');
        }
        return;
      }

      var skip = t.closest('[data-mcu-skip-deal]');
      if (skip && skip.closest('[data-mcu-dismissible]')) {
        storageSet(CASE_KEY);
        return;
      }

      var infoBtn = t.closest('[data-mcu-info]');
      if (infoBtn) {
        var root = infoBtn.closest('[data-magsafe-case-upsell][data-mcu-dismissible]');
        if (!root) return;
        ev.preventDefault();
        ev.stopPropagation();
        var wrap = infoBtn.closest('.mcu__info');
        if (!wrap) return;
        var open = !wrap.classList.contains('is-open');
        root.querySelectorAll('.mcu__info.is-open').forEach(function (el) {
          el.classList.remove('is-open');
        });
        if (open) wrap.classList.add('is-open');
      }
    },
    true
  );

  document.addEventListener('cart:update', function () {
    setTimeout(scan, 30);
    setTimeout(scan, 200);
  });

  if (typeof MutationObserver !== 'undefined') {
    var obs = new MutationObserver(function (mutations) {
      var relevant = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type !== 'childList') continue;
        var nodes = m.addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (node.nodeType !== 1) continue;
            if (
              (node.matches &&
                (node.matches(
                  '[data-mcu-offers], [data-gpu-offers], [data-magsafe-case-upsell][data-mcu-dismissible], [data-magsafe-wallet-upsell][data-mwu-dismissible], [data-gan-pack-upsell][data-gpu-dismissible]'
                ) ||
                  node.querySelector(
                    '[data-mcu-offers], [data-gpu-offers], [data-magsafe-case-upsell][data-mcu-dismissible], [data-magsafe-wallet-upsell][data-mwu-dismissible], [data-gan-pack-upsell][data-gpu-dismissible]'
                  )))
            ) {
            relevant = true;
            break;
          }
        }
        if (relevant) break;
      }
      if (relevant) scan();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
